import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const braveSearch = defineConnector({
  identifier: "braveSearch",
  name: "Brave Search",
  tagLine: "Independent web search index",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.search\\.brave\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "X-Subscription-Token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create a subscription token",
      items: [
        {
          kind: "markdown",
          content:
            "Register at the [Brave Search API dashboard](https://api-dashboard.search.brave.com/), subscribe to a plan, then create a key under **API Keys**.",
        },
      ],
    },
    {
      title: "Copy and paste the subscription token into the field below",
      items: [
        {
          kind: "input",
          label: "Subscription token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://api.search.brave.com/res/v1/web/search?q=test&count=1",
  },
});
